export default function initTabs() {
    document.querySelectorAll('[data-button]').forEach(button => {
        button.addEventListener('click', (e) => {
            let id = e.currentTarget.dataset.button;

            document.querySelectorAll('[data-view]').forEach(view => {
                view.classList.remove('active');
            });

            document.querySelector(`[data-view="${id}"]`).classList.add('active');
        });
    });
}
